module.exports = __webpack_public_path__ + "img/u4678.b3bcb52e.svg";